



























































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';

import createDebtor from '@/gql/debtor/createDebtor.gql';
import updateDebtor from '@/gql/debtor/updateDebtor.gql';
import getDebtor from '@/gql/debtor/getDebtor.gql';

const CommonFormWithDebtorEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    GroupAddressEditor,
  },
  props: {
    id: { type: [Number, String], default: -1 },
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const debtor = reactive({
      id: -1,
      code: '',
      name: '',
      address: {
        address: '',
        province: {
          id: '',
        },
        district: {
          id: '',
        },
        subdistrict: {
          id: '',
        },
        zipcode: '',
      },
      taxId: '',
      contactName: '',
      contactPhone: '',
      createdBy: '',
    });

    const { result: debtorResult, loading } = useQuery(getDebtor, computed(() => ({
      id: props.id,
    })));
    const _debtor = useResult(debtorResult, {}, (data) => data.debtor);
    watch(() => _debtor.value, (newVal, oldVal) => {
      if (props.id !== -1 && !loading.value && newVal !== oldVal) {
        debtor.id = _debtor.value.id;
        debtor.code = _debtor.value.code;
        debtor.name = _debtor.value.name;
        debtor.address.address = _debtor.value.address.address;
        debtor.address.province.id = _debtor.value.address.province.id;
        debtor.address.district.id = _debtor.value.address.district.id;
        debtor.address.subdistrict.id = _debtor.value.address.subdistrict.id;
        debtor.address.zipcode = _debtor.value.address.zipcode;
        debtor.taxId = _debtor.value.taxId;
        debtor.contactName = _debtor.value.contactName;
        debtor.contactPhone = _debtor.value.contactPhone;
        debtor.createdBy = _debtor.value.createdBy;
      } else {
        debtor.id = -1;
        debtor.code = '';
        debtor.name = '';
        debtor.address.address = '';
        debtor.address.province.id = '';
        debtor.address.district.id = '';
        debtor.address.subdistrict.id = '';
        debtor.address.zipcode = '';
        debtor.taxId = '';
        debtor.contactName = '';
        debtor.contactPhone = '';
        debtor.createdBy = '';
      }
    });

    const debtorInput = computed(() => ({
      id: props.id === -1 ? undefined : props.id,
      code: debtor.code,
      name: debtor.name,
      taxId: debtor.taxId,
      contactName: debtor.contactName,
      contactPhone: debtor.contactPhone,
      address: {
        ...debtor.address,
        address: debtor.address.address,
        province: debtor.address.province.id,
        district: debtor.address.district.id,
        subdistrict: debtor.address.subdistrict.id,
        zipcode: `${debtor.address.zipcode}`,
      },
      createdBy: {
        connect: me.id,
      },
    }));

    const refetchQueryList = ['getDebtors'];
    const createDebtorMutation = useMutation(createDebtor, () => ({
      variables: {
        input: debtorInput.value,
      },
      refetchQueries: refetchQueryList,
    }));
    const updateDebtorMutation = useMutation(updateDebtor, () => ({
      variables: {
        input: {
          ...debtorInput.value,
          createdBy: undefined,
        },
      },
      refetchQueries: refetchQueryList,
    }));
    const confirmModal = ref(null);
    createDebtorMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateDebtorMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createDebtorMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateDebtorMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.id !== -1) return updateDebtorMutation;
      return createDebtorMutation;
    });

    return {
      debtor,

      computedMutation,
      confirmModal,
      errorModal,
    };
  },
});

export default CommonFormWithDebtorEditor;
